export default __webpack_public_path__ + "static/media/users.5df47d91.svg";